import { flatten } from 'lodash'
import { useInfiniteQuery } from 'react-query'
import { parseQueryParams } from 'shared/helpers/utils'

import { useUserProvider } from '../../components/Context/UserContext'
import { CacheKeys } from '../../helpers/cacheKeys'
import { getJobs, GetJobsOptions } from '../../models/job'

export function useJobs({ enabled = true } = {}, options: GetJobsOptions = {}) {
  const { loggedInUser } = useUserProvider()

  const {
    data,
    fetchNextPage,
    hasNextPage,
    fetchPreviousPage,
    hasPreviousPage,
    isFetching,
    refetch,
    isLoading,
  } = useInfiniteQuery(
    `${CacheKeys.JOBS}-${loggedInUser?.id}-${JSON.stringify(options)}`,
    ({ pageParam = '1' }) => getJobs(pageParam, options),
    {
      enabled,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage) => (lastPage.next ? parseQueryParams(lastPage.next).page : null),
    }
  )

  return {
    jobs: flatten(data?.pages.map((page) => page.results)),
    jobsPages: data?.pages.map((page) => page.results),
    count: data?.pages[0]?.count,
    refetch,
    isLoading,
    isFetching,
    hasNextPage,
    fetchNextPage,
    hasPreviousPage,
    fetchPreviousPage,
  }
}
